import { type ApolloError } from '@apollo/client'
import { type GraphQLError } from 'graphql'
import { type Extensions } from './errorExtensions.types'

export interface EnterpriseApolloError extends ApolloError {
  graphQLErrors: ReadonlyArray<EnterpriseGraphQLError>
}

type EnterpriseGraphQLErrorExtensions =
  | Extensions
  | { code?: never; [key: string]: any } // eslint-disable-line @typescript-eslint/no-explicit-any
  | undefined

export interface EnterpriseGraphQLError extends GraphQLError {
  readonly extensions: EnterpriseGraphQLErrorExtensions
}

export function transformGraphQLError(error: GraphQLError): EnterpriseGraphQLError {
  return error
}
